export interface ISuggestion {
  productionTitle: string;
  confidential: boolean;
  type: number;
  role: string;
  suggestedBy: string;
  suggested: Date;
  statusID: number;
  _links: {
    role: {
      href: string;
    };
  };
}

export enum RoleStatus {
  Open,
  Closed,
  Cast,
}

export interface ISearchCriteria {
  skip: number;
  take: number;
  statusId?: string;
  search?: string;
  startDate?: Date;
  endDate?: Date;
}
